import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'ideal_dream_self'

export default function IdealDreamSelfPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Picture yourself 30 days from now...',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.idealDreamSelf.heading')}
      subheading={t('pages.onboarding.idealDreamSelf.subheading')}
      buttons={[
        {
          text: `📖 ${t('pages.onboarding.idealDreamSelf.options.journal')}`,
          value: 'Journaling dreams every morning',
        },
        {
          text: `🔮 ${t('pages.onboarding.idealDreamSelf.options.lucid')}`,
          value: 'Having lucid dreams',
        },
        {
          text: `🧠 ${t('pages.onboarding.idealDreamSelf.options.patterns')}`,
          value: 'Understanding dream patterns',
        },
        {
          text: `😌 ${t('pages.onboarding.idealDreamSelf.options.peace')}`,
          value: 'Feeling at peace with my subconscious',
        },
        {
          text: `🌟 ${t('pages.onboarding.idealDreamSelf.options.connected')}`,
          value: 'More connected to my inner self',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
